import React from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';

export default function ErrorFallback({ error, resetErrorBoundary }) {
  const isChunkError = error?.message?.includes('Loading chunk') || 
                       error?.message?.includes('Failed to fetch') ||
                       error?.name === 'ChunkLoadError';

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0a0f14',
      padding: '20px',
      fontFamily: 'system-ui'
    }}>
      <div style={{
        maxWidth: '500px',
        background: '#1a1f26',
        borderRadius: '16px',
        padding: '40px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
        textAlign: 'center'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          margin: '0 auto 24px',
          background: 'rgba(239, 68, 68, 0.1)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <AlertTriangle size={40} color="#ef4444" />
        </div>

        <h1 style={{
          fontSize: '24px',
          fontWeight: 'bold',
          color: '#fff',
          marginBottom: '12px'
        }}>
          {isChunkError ? 'Erreur de chargement' : 'Une erreur est survenue'}
        </h1>

        <p style={{
          fontSize: '15px',
          color: '#8b9aa8',
          marginBottom: '24px',
          lineHeight: '1.6'
        }}>
          {isChunkError 
            ? "L'application n'a pas pu charger correctement. Cela peut arriver après une mise à jour. Veuillez recharger la page."
            : error?.message || "Une erreur inattendue s'est produite."}
        </p>

        <div style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '12px 24px',
              background: 'linear-gradient(135deg, #06b6d4, #0891b2)',
              color: '#000',
              fontSize: '15px',
              fontWeight: '600',
              borderRadius: '8px',
              border: 'none',
              cursor: 'pointer',
              boxShadow: '0 0 20px rgba(6, 182, 212, 0.3)',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <RefreshCw size={18} />
            Recharger la page
          </button>

          <button
            onClick={() => window.location.href = '/'}
            style={{
              padding: '12px 24px',
              background: 'transparent',
              color: '#06b6d4',
              fontSize: '15px',
              fontWeight: '600',
              borderRadius: '8px',
              border: '1px solid #06b6d4',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <Home size={18} />
            Retour à l'accueil
          </button>
        </div>

        {!isChunkError && (
          <details style={{
            marginTop: '24px',
            textAlign: 'left',
            background: 'rgba(0,0,0,0.2)',
            padding: '16px',
            borderRadius: '8px'
          }}>
            <summary style={{
              color: '#8b9aa8',
              fontSize: '13px',
              cursor: 'pointer',
              marginBottom: '8px'
            }}>
              Détails techniques
            </summary>
            <pre style={{
              color: '#ef4444',
              fontSize: '12px',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              margin: 0
            }}>
              {error?.stack || error?.toString()}
            </pre>
          </details>
        )}
      </div>
    </div>
  );
}
